export const getImageByLink = (link) => {
  try {
    let newLink;

    const newValue = link?.split("/");

    if (newValue?.length > 1) {
      const withWWW = newValue[2].split(".");

      if (withWWW.length === 2) {
        newLink = withWWW[0];
      } else {
        newLink = withWWW[1];
      }
    } else if (newValue?.length === 1) {
      const withWWW = newValue[0].split(".");

      if (withWWW.length === 2) {
        newLink = withWWW[0];
      } else {
        newLink = withWWW[1];
      }
    }
    return newLink;
  } catch (error) {
    return;
  }
};
